import api from "../../api";
import {ReviewableId} from "platformed-client/types";
import {param, typedQuery} from "../typing";

export const reviewable = typedQuery(["reviewable", param<ReviewableId>("reviewableId")], async reviewableId => {
  return await api.reviewable.get(reviewableId);
});
